import { Component, Input } from '@angular/core';
import { RevisionNoticesDetailsXMLSection } from 'src/app/model/section/revision-notices-details-xml-section';

@Component({
  selector: 'app-revision-notices-details-xml-section',
  templateUrl: './revision-notices-details-xml-section.component.html',
  styleUrls: ['./revision-notices-details-xml-section.component.scss']
})
export class RevisionNoticesDetailsXmlSectionComponent {
  @Input() sections: RevisionNoticesDetailsXMLSection[] = [];

  constructor() {}
}
